import { isNullOrUndefined } from 'util';
import { Component, Input, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-cookie',
	templateUrl: './cookie.html'
})

export class CookieComponent {

	@ViewChild('template')
	modalTemplate: TemplateRef<any>;
	activeModal: NgbModalRef;

	private _link: string;

	@Input()
	set link(value: string) {
		this._link = value;
		// Questo setTimeout serve per uscire dal change
		// detection hook (evitando quindi una ExpressionChanged exception).
		setTimeout(() => this.openDialog());
	}

	openDialog() {
		if(this._link && isNullOrUndefined(localStorage.getItem(`nextagenda:privacy:${this._link}`))) {
			this.activeModal = this.modalService.open(
				this.modalTemplate,
				{
					backdrop: 'static', // prevent modal closing and background will be grayed out
			 		keyboard: false // pressing esc key model window will not get closed 
				}
			);
			this.activeModal.result.then(
				() => localStorage.setItem(`nextagenda:privacy:${this._link}`, 'true'),
				(e) => console.error(e)
			);
		}
	}

	get link(): string {
		return this._link;
	}

	constructor(
		public modalService: NgbModal,
		private changeRef: ChangeDetectorRef
	) { }
}



// WEBPACK FOOTER //
// ./src/app/home/cookie/cookie.ts